import {defineStore} from 'pinia';
import { ref, watch } from 'vue';
import api from '../api/client.js';
import { useWidgetStore } from './widget.js';

export const useConversationStore = defineStore('conversation', () => {

    const widgetStore = useWidgetStore();

    const getBotId = () => {
        return widgetStore.botId;
    }
    const conversationId = ref(localStorage.getItem('conversationId'));
    const listeningTo = ref(null);
    const setConversationId = (id) => {
        conversationId.value = id;
        localStorage.setItem('conversationId', id);
    }

    const newConversation = () => {
        localStorage.removeItem('conversationId');
        conversationId.value = null;
        messages.value = [];
        hasError.value = false;
        isThinking.value = false;
        tempMessage.value = null;
        tempSnippets.value = [];
        answerSuggestions.value = [];
        statusMessage.value = null;
    }

    const hasError = ref(false);
    const setHasError = (error) => {
        hasError.value = error;
    }

    const tempMessage = ref(null);
    const setTempMessage = (message) => {
        tempMessage.value = message;
    }

    const tempSnippets = ref([]);
    const setTempSnippets = (snippets) => {
        tempSnippets.value = snippets;
    }

    const statusMessage = ref(null);
    const setStatusMessage = (message) => {
        statusMessage.value = message;
    }

    const messages = ref([]);
    const setMessages = (messagesVal) => {
        console.log('setMessages', messagesVal);
        messages.value = messagesVal;
        console.log('setMessages', messages.value);
    }

    const answerSuggestions = ref([]);

    const setAnswerSuggestions = (suggestions) => {
        answerSuggestions.value = suggestions;
    }

    const isLoading = ref(true);

    const setIsLoading = (loading) => {
        isLoading.value = loading;
    }

    const isThinking = ref(false);
    const setIsThinking = (thinking) => {
        isThinking.value = thinking;
    }

    const retryResponse = () => {
        isThinking.value = true;
        hasError.value = false;
        api.retryMessage(getBotId(), conversationId.value);
    }   

    const listenToChat = () => {

        if(listeningTo.value === conversationId.value) {
            return;
        }

        if(listeningTo.value) {
            window.Echo.leave(`conversations.${listeningTo.value}`);
        }

        listeningTo.value = conversationId.value;
        
        window.Echo.private(`conversations.${conversationId.value}`)
                .listen('.Cierra\\LaravelBotflow\\Events\\NewBotMessage', () => {
                    hasError.value = false;
                    // const botMessage = e.message;
                    // messages.value.unshift({
                    //     id: botMessage.id,
                    //     text: botMessage.content,
                    //     isBotMessage: true,
                    //     sender: {
                    //         name: name.value
                    //     }
                    // });
                    loadConversation();
                    tempSnippets.value = [];
                    tempMessage.value = null;
                    isThinking.value = false;
                    setTimeout(() => {
                        const el = document.getElementById('prompt-textarea');
                        if(el) {
                            el.focus();
                        }
                    }, 100);
                })
                .listen('.Cierra\\LaravelBotflow\\Events\\NewMessageSnippetStreamed', (e) => {
                    const snippet = e.snippet;
                    const index = e.snippetIndex;
                    hasError.value = false;
                    tempSnippets.value.push({
                        index,
                        snippet
                    });
                    if(isThinking.value) {
                        generateTempMessage();
                    }
                })
                .listen('.Cierra\\LaravelBotflow\\Events\\StartingBackgroundFunction', (e) => {
                    statusMessage.value = e.statusText;
                })
                .listen('.Cierra\\LaravelBotflow\\Events\\MessageGenerationFailed', () => {
                    tempSnippets.value = [];
                    tempMessage.value = null;
                    isThinking.value = false;
                    hasError.value = true;
                })
                .listen('.Cierra\\LaravelBotflow\\Events\\AnswerSuggestionsGenerated', (e) => {
                    answerSuggestions.value = e.suggestions;
                });
    }


    const generateTempMessage = () => {
        const snippets = tempSnippets.value;
        if (!snippets.length) {
            return '';
        }
        const msg = snippets.sort((a, b) => a.index - b.index).map(snippet => snippet.snippet).join('');
        tempMessage.value = msg;
        return msg;
    }



    const sendMessage = (message) => {

        answerSuggestions.value = [];
        tempSnippets.value = [];
        tempMessage.value = null;

        statusMessage.value = null;


        // put to the beginning of messages the message
        messages.value.unshift({
            text: message,
            isBotMessage: false,
            sender: {
                name: "You (Guest)"
            }
        });
        isThinking.value = true;

        // get the conversation ID from the localStorage
        // if it doesn't exist, create a new one via api and store it to the storage

        if (!conversationId.value) {
            api.createConversation(getBotId()).then(({ data }) => {
                conversationId.value = data;
                localStorage.setItem('conversationId', conversationId.value);
                api.sendMessage(getBotId(), conversationId.value, { message });
            });
        } else {
            api.sendMessage(getBotId(), conversationId.value, { message, meta: {currentUrl: window.location.href, currentWindowTitle: document.title }});
        }


    }

    const loadConversation = async () => {
        return api.fetchConversation(getBotId(), conversationId.value).then(({ data }) => {
            console.log('test', data.data);
            setMessages(data.data.message_history);
            setAnswerSuggestions(data.data.suggestions);
            listenToChat();
        });
    }


    // watch conversationId and if set start echo channel listening
    watch(conversationId, (newValue) => {
        if (newValue) {
            listenToChat();
        }
    });



    return {
        conversationId,
        loadConversation,
        setConversationId,
        newConversation,
        messages,
        setMessages,
        answerSuggestions,
        setAnswerSuggestions,
        isLoading,
        setIsLoading,
        isThinking,
        setIsThinking,
        tempMessage,
        setTempMessage,
        tempSnippets,
        setTempSnippets,
        hasError,
        setHasError,
        statusMessage,
        setStatusMessage,
        retryResponse,
        listenToChat,
        sendMessage,
    }
});